import { promptToText } from "./WorkspacePromptEditor/promptToText";
import styles from "./moduleProgress.module.scss";

export type ProgressStep = { label: string; hint: string };

export const DRAFT_VET_STEPS: ProgressStep[] = [
  { label: "Set rubric", hint: "Shared criteria for every draft" },
  { label: "Add draft", hint: "Media plus the approved script" },
  { label: "Review findings", hint: "Pass, flags, and timestamps" },
];

export const SCRIPT_VET_STEPS: ProgressStep[] = [
  { label: "Set rubric", hint: "Shared criteria for every script" },
  { label: "Add script", hint: "Concept plus scene-by-scene copy" },
  { label: "Review findings", hint: "Pass, flags, and next actions" },
];

export function vetListStep(prompt: string, itemCount: number): 1 | 2 | 3 {
  if (promptToText(prompt).trim().length <= 20) return 1;
  return itemCount === 0 ? 2 : 3;
}

export function vetDetailStep(reviewing: boolean): 2 | 3 {
  return reviewing ? 3 : 2;
}

export function ModuleProgress({
  kicker,
  title,
  subtitle,
  steps,
  current,
}: {
  kicker?: string;
  title?: string;
  subtitle?: string;
  steps: ProgressStep[];
  current: number;
}) {
  return (
    <div className={styles.intro}>
      {kicker ? <p className={styles.kicker}>{kicker}</p> : null}
      {title ? <h2 className={styles.introTitle}>{title}</h2> : null}
      {subtitle ? <p className={styles.introSubtitle}>{subtitle}</p> : null}
      <ol className={styles.progress} aria-label="Progress">
        {steps.map((step, index) => {
          const number = index + 1;
          const isCurrent = current === number;
          const isDone = number < current;
          return (
            <li key={step.label} className={styles.progressItem}>
              {index > 0 ? (
                <span
                  className={`${styles.progressLine} ${
                    isDone || isCurrent ? styles.progressLineActive : ""
                  }`}
                />
              ) : null}
              <div className={styles.progressMark}>
                <span
                  className={`${styles.progressBadge} ${
                    isCurrent ? styles.progressBadgeCurrent : ""
                  } ${isDone ? styles.progressBadgeDone : ""}`}
                >
                  {number}
                </span>
                <p
                  className={`${styles.progressLabel} ${
                    isCurrent ? styles.progressLabelCurrent : ""
                  }`}
                >
                  {step.label}
                </p>
              </div>
              {index < steps.length - 1 ? (
                <span
                  className={`${styles.progressLine} ${
                    isDone ? styles.progressLineActive : ""
                  }`}
                />
              ) : null}
            </li>
          );
        })}
      </ol>
      <p className={styles.progressHint}>{steps[current - 1]?.hint}</p>
    </div>
  );
}
